import toggleMap from "../../../common/ToggleMap";
import starRating from "../../../common/StarRating";

export default {
  mixins: [toggleMap],
  mounted: function() {
    starRating();
  }
};
